<template>
  <div>
    <transition name="fade">
      <component :is="page" :amount.sync="limitAmount" :uuid.sync="uuid" @reset="resetForm" />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/common/layout/Footer.vue'
export default {
  components: { Footer },
  data() {
    return {
      limitAmount: null, // 가심사 결과 금액
      uuid: null, // 가심사 결과 uuid
    }
  },
  created() {
    _meta({
      titles: ['우리동네크라우드펀딩'],
    })
  },
  computed: {
    page() {
      // 폼(폼-로딩중) - 결과
      // const name = 'Result.vue'
      const name = this.limitAmount != null ? 'Result.vue' : 'Form.vue'
      return () => import(`@/pages/landing/woori-crowd/limit-inquiry/${name}`)
    },
  },
  methods: {
    resetForm() {
      this.limitAmount = null
      this.uuid = null
    },
  },
}
</script>
